<template>
    <van-popup v-model="show" closeable round position="bottom">
        <div class="search-address">
          <h6 class="search-title">Address</h6>
          <van-search
            v-model="searchVal"
            show-action
            placeholder="Enter your street address"
            @input="onSearchAddress(searchVal, addressval.countryNo)"
          >
            <template #action>
              <div  @click="onSearch" class="search global_pointer">OK</div>
            </template>
          </van-search>
          <ul class="street-list">
            <li class="global_pointer" v-for="(item, index) in street" :key="index" @click="setStreet(item)">{{ item.place_name }}</li>
          </ul>
        </div>
    </van-popup>
</template>
<script>
import { Popup, Search } from 'vant'
import { _ } from '@/common/underscore'
import request from "@/api/request/request.js";
export default {
    components: {
        [Popup.name]: Popup,
        [Search.name]: Search
    },
    props: {
        showSearchAddr: {
            type: Boolean,
            default: false
        },
        addressval: Object
    },
    data() {
        return {
            searchVal: '',
            street: [],
            show: this.showEditAddress
        }
    },
    watch: {
        show(val) {
            if (!val) {
                this.$emit('update:showSearchAddr', val)
            }
        },
        showSearchAddr(val) {
            console.log(val)
            this.show = val
        }
    },
    methods: {
        onSearchAddress: _.debounce((val, no, ctx) => {
            request.get(`https://api.mapbox.com/geocoding/v5/mapbox.places-permanent/${val}.json`,{
                country: no,
                types: 'address',
                access_token: 'pk.eyJ1Ijoid2FuZ2ppYW5ndGFvYXRzaG9wc2hvcHMiLCJhIjoiY2tqODFmbmt4MHNwbzJxcnV3czd0Mm40MSJ9.CBCjEz6Zd7VjJ-ArgH8qZw'
            }).then(res => {
                console.log(res)
                ctx.street = res.features
            })
        }, 1000),
        onSearch (val) {
            this.$emit('getStreet', {
                address: this.searchVal
            })
        },
        setStreet(item) {
            const place_name = item.place_name.split(',')
            const place = {}
            if (place_name.length && item.context && item.context.length) {
                place.address = place_name[0]
                item.context.forEach(item => {
                    const name = item.id.split('.')[0]
                    if (name === 'place') {
                        place.city = item.text
                    } else if (name === 'region') {
                        place.province = item.text
                    } else if (name === 'postcode') {
                        place.postCode = item.text
                    }
                })
            } else {
                place.address = place_name
            }
            this.$emit('getStreet', place)
        }
    }
}
</script>
<style lang="less" scoped>
.search-address{
  height: 200px;
  display: flex;
  flex-direction: column;
  .search-title{
    font-size: 8px;
    padding: 9px 7.5px;
  }
  .search{
    color: red;
  }
}
.street-list{
    font-size: 14px;
    padding: 0 10px 100px;
    overflow-y: scroll;
    li{
      border-bottom: 1px solid #ddd;
      padding: 5px 0;
      line-height: 18px;
    }
}
</style>